/**
 * Check if a value matches any of the target strings (case-insensitive)
 * @param {string} value - Value to check
 * @param {Array<string>} targets - Target strings to match against
 * @returns {boolean} - True if value matches any target
 */
export const matchesAny = (value, targets) => {
  const valueLower = value?.toLowerCase();
  return targets.some((target) => target.toLowerCase() === valueLower);
};

// Usage:
// const isCodeColumn = matchesAny(col, ["Code", "Meter SN", "Purchase ID"]);
// const isNameField = matchesAny(fieldName, ["firstName", "FIRSTNAME", "FirstName"]);
// const isEmail = matchesAny(type, ["Email", "EMAIL", "email"]);
